var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corner forced-flex-wrapper"},[_c('b-container',{},[(_vm.corner)?[_c('geo-chart-map',{attrs:{"feedback":_vm.feedback}})]:_c('hero-skeleton')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }